import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import Toggle from 'components/ReusableComponents/Toggle'

import styles from './EditActionDialog.module.scss'

const channelOptions = {
  EmailAndText: 'Text + Email together',
  TextWithEmailFallback: 'Email as a fallback'
}

const channelDescriptions = {
  EmailAndText:
    'Sends both a text and an email to guests at the same time—each with its own content—when a compliant customer–hotel relationship allows communication through both channels.',
  TextWithEmailFallback:
    'Sends a text first to guests with a valid mobile number when a compliant customer–hotel relationship allows text communication. If the text cannot be sent, a separate email version of the message is sent instead when the relationship allows email communication.'
}

function ConfigurationStep({
  isEnabled,
  setIsEnabled,
  sendAfterValue,
  setSendAfterValue,
  sendAfterUnit,
  setSendAfterUnit,
  medium,
  setMedium
}) {
  const defaultMax = sendAfterUnit === 'hours' ? 24 : 7
  const maxValue = Math.max(defaultMax, sendAfterValue || 0)
  const valueOptions = Array.from({ length: maxValue }, (_, i) => i + 1).reduce(
    (acc, n) => ({ ...acc, [n]: String(n) }),
    {}
  )

  const unitOptions = {
    hours: 'hours',
    days: 'days'
  }

  const handleUnitChange = e => {
    const newUnit = e.target.value
    setSendAfterUnit(newUnit)
    const newMax = newUnit === 'hours' ? 24 : 7
    if (sendAfterValue > newMax) {
      setSendAfterValue(newMax)
    }
  }

  return (
    <div className={styles.configurationStep}>
      <label className={styles.enabledToggle}>
        <Toggle
          checked={isEnabled}
          handleChange={e => setIsEnabled(e.target.checked)}
          isGray={false}
        />
        <span className={styles.enabledLabel}>Enabled</span>
      </label>

      <p className={styles.description}>
        This message is sent after a set period when a guest subscribes through the widget
        but does not make a booking.
      </p>

      <div className={styles.sendAfterSection}>
        <span className={styles.sectionLabel}>Send after</span>
        <div className={styles.sendAfterInputs}>
          <Dropdown
            className={styles.valueDropdown}
            options={valueOptions}
            value={String(sendAfterValue)}
            onChange={e => setSendAfterValue(Number(e.target.value))}
            isSortedAlphabetically={false}
          />
          <Dropdown
            className={styles.unitDropdown}
            options={unitOptions}
            value={sendAfterUnit}
            onChange={handleUnitChange}
            isSortedAlphabetically={false}
          />
        </div>
      </div>

      <div className={styles.channelSection}>
        <Dropdown
          label="Message channel strategy"
          options={channelOptions}
          value={medium}
          onChange={e => setMedium(e.target.value)}
          isSortedAlphabetically={false}
        />
        <p className={styles.channelDescription}>{channelDescriptions[medium]}</p>
      </div>
    </div>
  )
}

export default ConfigurationStep

